import { lazy } from 'react'
import { Route } from 'commons/types/route'
import { CONTENT_MANAGEMENT } from 'commons/constants/permissions'

const ContentManagementPage = lazy(() => import('pages/ContentManagement'))

export default [
  {
    path: '/contentManagement',
    component: ContentManagementPage,
    permissions: CONTENT_MANAGEMENT,
  },
] as Route[]
